import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-detail-c" }

import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { BaseTable, BaseButton, useTableColumn } from 'xrk-components';

import { supplierViewDetail } from '../data-source/apis';
import {
  indexCol,
  supplierNameCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  gysSumScaleCol,
  orderPriceCol,
  payStatusCol
} from '../fields/columns';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';
import { batchDownLoadReceipt } from '@/common/hooks/order/order-download';


export default /*#__PURE__*/_defineComponent({
  __name: 'finished-order-detail-b',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const detailInfo = computed(() => {
  return {
    projectStructureType: +route.query.projectStructureType,
    aspOrderId: +route.query.aspOrderId,
    sceneType: +route.query.sceneType
  };
});
const taxType = computed(() => {
  return route.meta.taxType as number;
});
const tableColumns = [
  indexCol,
  supplierNameCol,
  settlementTaskCountCol,
  detailInfo.value.sceneType !== 19 && taskPriceCol, //协定服务项目查看明细不显示单价字段
  projectPayPriceCol,
  gysSumScaleCol,
  orderPriceCol,
  {
    ...payStatusCol,
    formatter({ cellValue }) {
      return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
    }
  },
  useTableColumn({
    align: 'center',
    fixed: 'right',
    label: '操作',
    width: 230,
    render({ row }) {
      return (
        <>
          <div>
            <BaseButton
              disabled={!row.isExistReceiptUrl}
              onClick={async () => {
                // 下载回单
                await batchDownLoadReceipt({
                  downloadType: 504,
                  downloadList: [
                    {
                      id: row.id,
                      aspOrderId: detailInfo.value.aspOrderId,
                      aspSupplierOrderId: row.id,
                      orderType: 1
                    }
                  ]
                });
              }}
              type="text"
            >
              下载回单
            </BaseButton>
            <BaseButton
              onClick={async () => {
                const pathMapDetailC = {
                  1: '/main/asp/finished-order/detail-c',
                  2: '/main/asp/finished-labor-order/detail-c'
                };
                // 查看明细
                router.push({
                  path: pathMapDetailC[taxType.value],
                  query: {
                    projectStructureType: 1,
                    aspSupplierOrderId: row.id,
                    isSupplierOrder: 1,
                    needBack: 1,
                    isEdit: 0,
                    hidePayStatus: 1
                  }
                });
              }}
              type="text"
            >
              查看明细
            </BaseButton>
          </div>
        </>
      );
    }
  })
].filter(Boolean);

const dataList = ref([]);
const getListAjax = async () => {
  const reqData = {
    projectStructureType: detailInfo.value.projectStructureType,
    aspOrderId: detailInfo.value.aspOrderId
  };
  const { data } = await supplierViewDetail(reqData);
  dataList.value = [data];
};
getListAjax();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTable), {
      data: dataList.value,
      columns: _unref(tableColumns)
    }, null, 8, ["data", "columns"])
  ]))
}
}

})